import React, { useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { getOrders } from "./redux/actions/orders";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

export default function BarChart() {
  const dispatch = useDispatch();
  const { orders } = useSelector((state) => state.orders);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  const options = {
    plugins: {
      title: {
        display: true,
        text: "EVD Data for 2014",
      },
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      month: "long",
    });
  };

  const cc = orders
    .map((order) => parseInt(order.attributes.fives))
    .reduce((a, b) => a + b, 0);

  console.log("Fives sum ", cc);

  const labels = orders.map((order) => formatDate(order.attributes.orderDate));
  console.log("LABELS ", labels);
  const data = {
    labels,
    datasets: [
      {
        label: "five",
        data: labels.map((label) =>
          orders
            .map((order) =>
              formatDate(order.attributes.orderDate) === label
                ? parseInt(order.attributes.fives)
                : 0
            )
            .reduce(
              (previousValue, currentValue) => currentValue + previousValue,
              0
            )
        ),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "ten",
        data: labels.map((label) =>
          orders
            .map((order) =>
              formatDate(order.attributes.orderDate) === label
                ? parseInt(order.attributes.tens)
                : 0
            )
            .reduce(
              (previousValue, currentValue) => currentValue + previousValue,
              0
            )
        ),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: "fifteen",
        data: labels.map((label) =>
          orders
            .map((order) =>
              formatDate(order.attributes.orderDate) === label
                ? parseInt(order.attributes.fifteens)
                : 0
            )
            .reduce(
              (previousValue, currentValue) => currentValue + previousValue,
              0
            )
        ),
        backgroundColor: "rgba(0, 255, 0, 0.5)",
      },
      {
        label: "twenty five",
        data: labels.map((label) =>
          orders
            .map((order) =>
              formatDate(order.attributes.orderDate) === label
                ? parseInt(order.attributes.twenty_fives)
                : 0
            )
            .reduce(
              (previousValue, currentValue) => currentValue + previousValue,
              0
            )
        ),
        backgroundColor: "rgba(255, 240, 0, 0.5)",
      },
      {
        label: "fifty",
        data: labels.map((label) =>
          orders
            .map((order) =>
              formatDate(order.attributes.orderDate) === label
                ? parseInt(order.attributes.fifties)
                : 0
            )
            .reduce(
              (previousValue, currentValue) => currentValue + previousValue,
              0
            )
        ),
        backgroundColor: "rgba(255, 128, 0, 0.5)",
      },
      {
        label: "hundred",
        data: labels.map((label) =>
          orders
            .map((order) =>
              formatDate(order.attributes.orderDate) === label
                ? parseInt(order.attributes.hundreds)
                : 0
            )
            .reduce(
              (previousValue, currentValue) => currentValue + previousValue,
              0
            )
        ),
        backgroundColor: "rgba(102, 102, 255,0.5)",
      },
    ],
  };

  if (orders) return <Bar options={options} data={data} />;
  else return <></>;
}
